<template>
  <v-container
    class="my-12"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="8"
      >
        <v-card>
          <v-card-title primary-title>
            <v-col
              class="text-center"
            >
              <v-icon x-large class="blue--text text--darken-2">
                mdi-account-plus
              </v-icon>
              <div class="display-1">
                Registrieren
              </div>
              <br>
              <p v-show="!registerSuccessMessage">
                Hier kannst Du dich kostenlos für den Kegelmanager registrieren.<br>
                Einfach folgende Felder ausfüllen und schon kann es losgehen.
              </p>
            </v-col>
          </v-card-title>

          <v-card-text v-if="!registerSuccessMessage">
            <v-text-field
              v-model="email"
              :rules="emailRules"
              :error-messages="errorMessageEmail"
              prepend-icon="mdi-email"
              type="email"
              name="email"
              label="E-Mail-Adresse"
              required
            />

            <v-text-field
              prepend-icon="mdi-security"
              hint="Passwort eingeben"
              v-model="mPassword"
              name="password"
              label="Passwort"
              required
              :rules="passwordRules"
              :error-messages="errorMessagePassword"
              :type="showPW ? 'password' : 'text'"
              @click:append="() => (showPW = !showPW)"
              :append-icon="showPW ? 'mdi-eye' : 'mdi-eye-off'"
            />

            <v-text-field
              prepend-icon="mdi-security"
              hint="Passwort eingeben"
              v-model="mPassword2"
              name="password2"
              label="Passwort wiederholen"
              required
              data-vv-as="password"
              :rules="password2Rules"
              :error-messages="errorMessagePassword2"
              :type="showPW2 ? 'password' : 'text'"
              @click:append="() => (showPW2 = !showPW2)"
              :append-icon="showPW2 ? 'mdi-eye' : 'mdi-eye-off'"
            />

            <v-icon>mdi-arrow-right</v-icon>
            <router-link to="/agb" target="_blank">
              Hier geht es zu den Allgemeinen Geschäftsbedingungen (öffnet in neuem Fenster/Tab)
            </router-link>
            <v-switch
              color="primary"
              :rules="agbRules"
              :error-messages="errorMessageAgb"
              label="Hiermit akzeptiere ich die Allgemeinen Geschäftsbedingungen"
              v-model="agb"
              required
              false-value="false"
              true-value="ja"
            />

            <my-alert
              v-if="this.$store.state.error"
              type="error"
              :error="this.$store.state.error"
              :title="this.$store.state.errorTitle"
            />
            <v-card-actions>
              <v-btn
                outlined
                large
                block
                class="primary--text"
                @click.native.stop="gameRegister()"
                :loading="this.$store.state.loading"
              >
                Registrieren <v-icon right class="blue--text text--darken-2">
                  mdi-account-plus
                </v-icon>
              </v-btn>
            </v-card-actions>
            <br>
            <p class="text-center">
              <router-link to="/login">
                Schon angemeldet? Dann hier Einloggen!
              </router-link>
            </p>
          </v-card-text>
          <v-card-text
            v-else
          >
            Danke für die Registrierung. Schau in deinem E-Mail Eingang nach um dich einzuloggen.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_LOADING } from '../../store/mutation-types'
const emailCheck = require('../../vendor/checkEmail')

export default {
  name: 'Register',
  metaInfo: {
    title: 'Registrieren'
  },
  data () {
    return {
      registerSuccessMessage: false,
      registerProcess: false,
      showPW: true,
      showPW2: true,
      email: '',
      mPassword: '',
      mPassword2: '',
      agb: false,
      agbRules: [],
      emailRules: [],
      passwordRules: [],
      password2Rules: [],
      errorMessageEmail: [],
      errorMessagePassword: [],
      errorMessagePassword2: [],
      errorMessageAgb: []
    }
  },
  methods: {
    validateAll: (email, password, passwordCheck, agb) => {
      const ret = { status: true }
      if (!emailCheck(email)) {
        ret.email = true
        ret.status = false
      }
      if (password.length == null || password.length < 8) {
        ret.password = true
        ret.status = false
      }
      if (password !== passwordCheck) {
        ret.passwordCheck = true
        ret.status = false
      }

      if (agb !== 'ja') {
        ret.status = false
        ret.agb = true
      }

      return ret
    },
    gameRegister: async function () {
      this.$store.commit(ROOT_LOADING, true)
      const check = this.validateAll(this.email, this.mPassword, this.mPassword2, this.agb)
      this.emailRules = []
      this.passwordRules = []
      this.password2Rules = []
      this.agbRules = []
      this.errorMessageEmail = []
      this.errorMessagePassword = []
      this.errorMessagePassword2 = []
      this.errorMessageAgb = []

      if (!check.status) {
        // show errors
        this.registerProcess = false
        if (check.email) {
          this.emailRules = this.errorMessageEmail = ['Fehlerhafte E-Mail-Adresse!']
        }
        if (check.password) {
          this.passwordRules = this.errorMessagePassword = ['Passwort erforderlich, mindestens 8 Zeichen!']
        }

        if (check.passwordCheck) {
          this.password2Rules = this.errorMessagePassword2 = ['Passwörter stimmen nicht überein']
        }

        if (check.agb) {
          this.agbRules = this.errorMessageAgb = ['Akzeptiere die Allgemeinen Geschäftsbedingungen']
        }
        this.$store.commit(ROOT_LOADING, false)
        return false
      }

      const registerUser = await this.$store.dispatch('loginRegisterStore/registerUser', {
        email: this.email,
        password: this.mPassword
      })
      if (registerUser) {
        this.$store.commit('loginRegisterStore/AUTH_SET_LOGIN_EMAIL', this.email)
        this.$store.commit('loginRegisterStore/AUTH_WAS_VERIFY_EMAIL_SEND', true)
        this.$router.replace({ path: '/email/activate' })
      }
    }
  },
  async created () {
    // check if user is already logged in and then redirect to home
    await this.$store.dispatch('matchEvaluationInProgress')
    if (this.$store.state.loggedIn || this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>
